import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=2aed8171&ts=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__